// extracted by mini-css-extract-plugin
export default {"container":"Credits_container__oMyNN","tableContainer":"Credits_tableContainer__7pseg"};